const ErrorPage: React.FC = () => (
   <div className="error">OOPS WRONG PAGE !!</div>
);

export default ErrorPage;
